import { render, staticRenderFns } from "./setSurgical.vue?vue&type=template&id=0251c22f&scoped=true&"
import script from "./setSurgical.vue?vue&type=script&lang=js&"
export * from "./setSurgical.vue?vue&type=script&lang=js&"
import style0 from "./setSurgical.vue?vue&type=style&index=0&id=0251c22f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0251c22f",
  null
  
)

export default component.exports